import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';

import { useStateValue } from '../context/state.jsx';
import { setProjectViewType, setProjectGroupBy, setProjectGroupByActivityCode } from '../context/datasets.js';

const ActivityCodeList = ({
	projectViewType,
	projectGroupBy,
	projectGroupByActivityCode,
	projectActivityCodesTree,
	projectActivityCodesTreeSequence
}) => {
	const [, dispatch] = useStateValue();
	const activityCodeListItemClick = type => {
		dispatch(setProjectViewType('Group List'));
		dispatch(setProjectGroupBy('Activity Code'));
		dispatch(setProjectGroupByActivityCode(type));
	};

	if (!projectActivityCodesTreeSequence) {
		return null;
	}

	const activityCodeItems = [];
	for (let i = 0; i < projectActivityCodesTreeSequence.length; i++) {
		const id = projectActivityCodesTreeSequence[i];
		const checked = projectViewType === 'Group List' &&
			projectGroupBy === 'Activity Code' &&
			projectGroupByActivityCode === id;

		const classes = classnames('groupByActivityCodeListItemWrapper', {'no-bottom-border': i === projectActivityCodesTreeSequence.length - 1});
		activityCodeItems.push(
			<div
				key={id}
				className={classes}>
				<ListGroupItem
					onClick={() => { activityCodeListItemClick(id); }}>
					<input
						type="radio"
						className="activityCodeListRadio"
						name="activityCodeListRadio"
						value={id}
						checked={checked}
						readOnly />
					{projectActivityCodesTree[id].name}
				</ListGroupItem>
			</div>
		);
	};
	const header = (
		<div>
			<input
				type="radio"
				className="groupByRadio"
				name="groupByRadio"
				value="Activity Code"
				checked={projectGroupBy === 'Activity Code'}
				readOnly />
			Activity Code
			<span className="glyphicon glyphicon-plus rightGlyph"></span>
			<span className="glyphicon glyphicon-minus rightGlyph"></span>
		</div>
	);
	return (
		<Panel className="activityCodeListPanel">
			<Panel.Heading>
				<Panel.Title toggle>{header}</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<ListGroup>
					{activityCodeItems}
				</ListGroup>
			</Panel.Collapse>
		</Panel>
	);
};

ActivityCodeList.propTypes = {
	projectViewType: PropTypes.string,
	projectGroupBy: PropTypes.string,
	projectGroupByActivityCode: PropTypes.string,
	projectActivityCodesTree: PropTypes.object,
	projectActivityCodesTreeSequence: PropTypes.array
};

export default ActivityCodeList;